import React, { Component } from 'react';
import { Container } from 'reactstrap';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons';
import LocaleLink from '../../Routes/LocaleLink'

class PartnersPageTalkAboutUs extends Component
{
    parallaxLeft = React.createRef()
    parallaxRight = React.createRef()

    state = {
        direction: this.props.direction ?? 'left'
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
    }

    onScroll = (e) => {
        const scrollY = window.scrollY
        const astroDelta = scrollY / this.parallaxLeft.current.offsetHeight
        this.parallaxLeft.current.style.marginTop = Math.round(40 * astroDelta) + 'px'
        this.parallaxRight.current.style.marginTop = Math.round(40 * astroDelta) + 'px'
    }

    handleMoveAstronaut = (e) => {
        if (e.nativeEvent.pageX < window.innerWidth / 2){
            this.setState({ direction: 'left' })
        } else {
            this.setState({ direction: 'right' })
        }
    }

    render() {
        const { left_link, left_title, left_subtitle, right_link, right_title, right_subtitle } = this.props;

        return (
            <>
                <section className="spirit-extsn" onMouseMove={this.handleMoveAstronaut}>
                    <Container>
                        <div className="spirit-block">
                            <div className="spirit-text">
                                <LocaleLink to={left_link}>
                                    <h4>{left_title}</h4>
                                    <FontAwesomeIcon icon={faArrowLeft} className="icon-arrow-right d-none d-lg-inline-block"/>
                                    <p>
                                        {left_subtitle}
                                    </p>
                                    <FontAwesomeIcon icon={faArrowRight} className="icon-arrow-right d-lg-none"/>
                                </LocaleLink>
                            </div>
                            <div className="spirit-text">
                                <LocaleLink to={right_link}>
                                    <h4>{right_title}</h4>
                                    <p>
                                        {right_subtitle}
                                    </p>
                                    <FontAwesomeIcon icon={faArrowRight} className="icon-arrow-right"/>
                                </LocaleLink>
                            </div>
                        </div>
                    </Container>
                    <div className="astronaute" data-direction={this.state.direction}>
                        <span className="astronaute-left" ref={this.parallaxLeft}/>
                        <span className="astronaute-right" ref={this.parallaxRight}/>
                    </div>
                </section>
            </>
        )
    }
}

export default PartnersPageTalkAboutUs;
